import React from "react";
import { Typography } from "@material-ui/core";

export interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
  
export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}